<!-- 任务卡片组件 -->
<template>
  <div>
    <div class="chat-card" @click="toRouter">
      <div class="chat-status" v-if="cardData.status === 'COMPLETED'">已完成</div>
      <div class="chat-text">
        <div class="answer-title">{{ currentCard?.title }}</div>
        <div class="answer-tips">{{ currentCard?.tips }}</div>
      </div>
      <div class="chat-img" :style="`width: ${currentCard?.width || '56'}px`">
        <img class="img" :src="currentCard?.imgUrl" alt="">
      </div>
    </div>
    <!-- 视频容器 -->
    <div 
      v-if="isShowVideo" 
      class="video-container"
      @click="closeVideo"
    >
      <video 
        ref="videoPlayer"
        class="video-player"
        controls 
      >
        <source :src="cardData.videoUrl" type="video/mp4">
      </video>
    </div>
    <!-- <div class="send-time">09月01日  16:29</div> -->
  </div>
</template>

<script>
import {CHAT_LIST} from "@/consts";
import { videoComplete } from '@/api/dialogue'
import { markDialogueTaskEntry } from '@/utils/taskNavigation';

export default {
  name: 'ChatAnswerSheet',
  components: {
  },
  props: {
    cardData: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  data() {
    return {
      cardList: CHAT_LIST,
      isShowVideo: false
    };
  },
  computed: {
    // 当前类型卡片
    currentCard() {
      return this.cardList[this.cardData.item_type]
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    openTaskPage() {
      markDialogueTaskEntry();
      this.$router.push({
        path: this.currentCard.hrefUrl,
        query: { id: this.cardData.id, status: this.cardData.status }
      });
    },
    toRouter() {
      console.log(this.cardData)
      console.log(this.currentCard)

      if(this.cardData.status === 'COMPLETED') {
        if(this.cardData.item_type === 'video') {
          this.isShowVideo = true
          this.$nextTick(() => {
            this.$refs.videoPlayer.play();
          });
          return;
        }
        if(this.cardData.item_type === 'scale') {
          // if(this.cardData.instance_id) {
          //   this.$router.push(`/reportDetails/${this.cardData.instance_id}`);
          // }
          this.openTaskPage();
          return;
        }
        if(this.cardData.item_type === 'auto_mindset_recognize') {
          if(this.cardData.instance_id) {
            markDialogueTaskEntry();
            this.$router.push(`/automaticThinkingReport/${this.cardData.instance_id}`);
          }
          return;
        }
        if(this.cardData.item_type === 'cognize_reestablish') {
          if(this.cardData.instance_id) {
            markDialogueTaskEntry();
            this.$router.push(`/cognitiveReconstructionReport/${this.cardData.instance_id}`);
          }
          return;
        }
        if(['problem_goal_motive', 'mood_recognize_named', 'current_mood_score', 'twelve_mind_distort', 'happly_exercise_list', 'behaviour_exercise_plan', 'goal_progress', 'therapy_calendar', 'schedule', 'relax_exercise'].includes(this.cardData.item_type)) {
          this.openTaskPage();
          return;
        }
        this.$toast({
          message: '该任务已完成',
          duration: 1500
        })
      } else {
        if(this.cardData.item_type === 'video') {
          this.isShowVideo = true
          this.$nextTick(() => {
            this.$refs.videoPlayer.play();
          });
          this.completeVideo();
          return;
        }
        this.openTaskPage();
      }
    },
    closeVideo() {
      this.$refs.videoPlayer.pause();
      this.isShowVideo = false
    },
    async completeVideo() {
      try {
        await videoComplete({ id: this.cardData.id });
        this.$set(this.cardData, 'status', 'COMPLETED');
        this.$emit('taskCompleted', { id: this.cardData.id });
      } catch (error) {
        console.log(error);
        this.$toast('视频完成状态保存失败，请稍后重试');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 290px;
  height: 67px;
  border-radius: 12px 12px 12px 0px;
  padding: 0 13px 0 19px;
  background: #EDF4FC;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  .chat-text {
    .answer-title {
      font-size: 16px;
      font-weight: 400;
      color: $text-color;
    }
    .answer-tips {
      font-size: 9px;
      font-weight: 400;
      margin-top: 5px;
      color: #a6a6a6;
    }
  }
  .chat-img {
    width: 56px;
    .img {
      width: 100%;
    }
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9D9FA3;
  margin-top: 4px;
}
.chat-status {
  position: absolute;
  top: 0;
  left: 20px;
  width: 41.8px;
  height: 13.2px;
  opacity: 1;
  border-radius: 0 0 5.5px 5.5px;
  background: rgba(0, 122, 255, 1);
  font-size: 8.8px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 13.2px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
}
.video-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video-player {
  width: 100%;
  max-height: 100%;
}
</style>
